"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconLoading = function IconLoading(_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (0, _classnames.default)('icon', 'icon--loading', classes),
    "data-testid": "loading-icon",
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement("title", null, "Loading Icon"), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-665.000000, -510.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(517.000000, 180.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(51.000000, 310.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(98.000000, 19.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.9999978,1.5 C19.1977031,1.5 24.9999978,7.30229692 24.9999978,14.5 C24.9999978,21.6977031 19.1977031,27.5 11.9999978,27.5 C4.86856728,27.5 -0.896110794,21.8149445 -1.00000222,14.705832 C-1.00795515,14.1536061 -0.566822893,13.6994033 -0.0145969848,13.6913416 C0.537628924,13.6832799 0.991831766,14.1244122 0.999893458,14.6766381 C1.08772339,20.6929887 5.96205979,25.5 11.9999978,25.5 C18.0931336,25.5 22.9999978,20.5931336 22.9999978,14.5 C22.9999978,8.40686642 18.0931336,3.5 11.9999978,3.5 C10.0058271,3.5 8.1226692,4.01257551 6.48717101,4.9850339 C6.01246245,5.26729304 5.39881888,5.11128196 5.11655973,4.6365734 C4.83430058,4.16186484 4.99031166,3.54822127 5.46502022,3.26596212 C7.41124277,2.10874871 9.64773261,1.5 11.9999978,1.5 Z"
  })))))));
};

IconLoading.propTypes = {
  classes: _propTypes.default.string
};
IconLoading.defaultProps = {
  classes: ''
};
var _default = IconLoading;
exports.default = _default;